import { ShieldCheck } from "lucide-react";
import { Container, Button, ProductImage } from "@/components/atoms";

// Hero — founder portrait + headline + CTA (frame 4:14).
export function HomeHero() {
  return (
    <section className="bg-gradient-to-br from-medical-grey via-white to-leaf-green/5">
      <Container className="grid items-center gap-8 py-12 md:grid-cols-2 md:py-20">
        <div className="flex flex-col gap-5">
          <span className="inline-flex w-fit items-center gap-2 rounded-pill bg-leaf-green/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-leaf-green-ink">
            <ShieldCheck size={14} /> Physician Formulated · AACM-Certified
          </span>
          <h1 className="font-condensed text-4xl font-bold leading-[1.05] text-night-blue md:text-5xl lg:text-6xl">
            CBD wellness,{" "}
            <span className="text-leaf-green-ink">rooted in science</span> — not
            folklore.
          </h1>
          <p className="max-w-md text-lg text-night-blue/70">
            Condition-specific formulas developed by Dr. Elaine Burns, and
            tested to a 99.5% accuracy rating. The relief your body’s been
            asking for.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button to="/shop" size="lg">
              Shop All Products
            </Button>
            <Button to="/about" variant="outline" size="lg">
              Meet Dr. Burns
            </Button>
          </div>
        </div>
        <div className="relative mx-auto w-full max-w-sm">
          <div
            aria-hidden
            className="absolute -inset-3 -z-10 rounded-[2rem] bg-gradient-to-br from-leaf-green/25 via-transparent to-healthy-blue/25 blur-2xl"
          />
          <div className="rounded-[20px] bg-gradient-to-br from-healthy-blue via-healthy-blue/80 to-leaf-green/70 p-1 shadow-[0_18px_44px_rgba(60,113,184,0.28),0_4px_12px_rgba(0,0,0,0.08)]">
            <ProductImage
              src="https://firebasestorage.googleapis.com/v0/b/drburns-web.firebasestorage.app/o/about%2Fdr-burns.png?alt=media"
              alt="Dr. Elaine Burns"
              name="Dr. Elaine Burns"
              className="aspect-square w-full !rounded-2xl bg-gradient-to-br from-medical-grey to-white"
              imgClassName="object-cover object-top"
            />
          </div>
        </div>
      </Container>
    </section>
  );
}
